import * as React from 'react';
import Modal from '../_common/modal';
import DataSortOptions from '../data-sort-options';
import { ReactComponent as SortIcon } from '../../assets/svg/icons/sort.svg';
import { getText } from '../../helpers';

const sort = getText('generic.sort');

function DataSort(props: DataSortProps) {
    const [modalIsOpen, setModalOpen] = React.useState<boolean>(false);
    const { queryString, updateQueryString, sortOptions, disabled } = props;

    return (
        <>
            <button className="button--select-control data-controls__button" type="button" onClick={() => setModalOpen(true)} disabled={disabled}>
                <SortIcon />
                {sort}
            </button>
            <Modal open={modalIsOpen} onClose={() => setModalOpen(false)} isFullScreen={window.innerWidth < 1024}>
                <DataSortOptions
                    queryString={queryString}
                    updateQueryString={(name: string, id: string) => {
                        setModalOpen(false);
                        updateQueryString(name, id);
                    }}
                    sortOptions={sortOptions}
                />
            </Modal>
        </>
    );
}

export default React.memo(DataSort);
